export default {
    BASE_URL: (process.env.NODE_ENV === 'development') ? "http://localhost:7100" : "https://demoserver.checkmate.vulmiqi.com"
    // BASE_URL: "http://localhost:5000",

};